
export default {
    home: {
        bindDesc: '連携について',
        bindDesc1: '１．ゲストログイン時の進行状況（課金内容も含め）はブラウザのアンインストール・変更・データ削除によって削除されます。ゲームの進行状況などを保護するため、アカウント連携をおすすめします。',
        bindDesc2: '２．アカウント連携後、他の端末とブラウザでログインしてプレイいただくことが可能です。',
        bindDesc3: '３．連携アカウントを変更する際、連携済みのアカウントを一度解除してから新アカウントの連携を行ってください。',
        numberBind: 'アカウント連携',
        bindBtn: '連携',
        rebindBtn: '連携を解除する',
        modalTit1: 'メールアドレス',
        modalTit2: 'パスワード',
        modalTit3: '認証番号',
        modalTit4: 'パスワード確認',
        placeHolder1: 'メールアドレスをご入力ください',
        placeHolder2: 'パスワードをご入力ください',
        placeHolder3: '認証番号をご入力ください',
        placeHolder4: 'パスワードをご確認ください',
        placeHolder5: '確認のため、パスワードをもう一度ご入力ください',
        forgetPass: 'パスワードを忘れた方',
        getCode: '認証メールを送信する',
        isBind: '連携を解除しますか？',
        passwordInfo1: 'パスワードをもう一度ご入力ください',
        twoDiff: 'パスワードが一致しませんでした!',
        correctEmailAd: 'メールアドレスを正しくご入力ください!',
        error1: '不明なエラーが発生しました。管理者にご連絡ください',
        customer: 'ゲスト',
        loginSuc: 'ログインに成功しました',
        message1: '未登録のアカウントです。当アカウントでログインしたい場合は、まずゲストアカウントと連携してください',
        plsRetry: 'エラーが発生しました。もう一度お試しください',
        resetSuc: 'リセットに成功しました',
        bindSuc: '連携に成功しました',
        isBindOthers: 'ご指定のアカウントは既に他のアカウントと連携済みです',
        bindErrRetry: 'エラーが発生しました。もう一度お試しください',
        removeSuc: '連携を解除しました',
        NotRemove: 'アカウント保護の為、単一アカウントと連携する場合は連携を解除することができません',
        inputEm: 'メールアドレスをご入力ください',
        // 新增部分
        uncertifiedInfo: 'このアカウントは未登録のため、ゲストアカウントに切り替えました。このアカウントでログインしたい場合は、まずゲストアカウントと連携してください。',
        userCancelled: 'ログインがキャンセルされ、または承認されませんでした',
        reBack: '戻る',
        binded: '連携済み',
        username: 'ユーザー名',
        inputName: 'ユーザー名をご入力ください',
        supportType: '日本語文字、半角英字、数字を組み合わせて 8 ～３２文字でご入力ください',
        accSupport: '日本語文字、半角英字、数字を組み合わせて 8 ～３２文字でご入力ください',
        passSupport: '半角英字の大文字と小文字、数字を組み合わせて 8 文字以上で入力してください',
        passErrorMsg: '半角英字の大文字と小文字、数字を組み合わせて 8 文字以上で入力してください',
        uaNotBlank: 'ユーザー名は空白またはスペースのみではなれませんので、もう一度ご入力ください',
        selfDefine: 'カスタマイズ',
        // 发放奖励
        award1: 'アカウントのセキュリティを強化し、アカウント紛失のリスクを減らすため、アカウント連携を行うことをおすすめします',
        award2: 'アカウント連携を行うと、ゲームデータがより安全になり、複数のデバイスでプレイできるようになります',
        award3: 'アカウント連携されたユーザー様には、ゲーム内メールにて',
        award4: '元宝×200',
        award5: 'を配布いたします~',
        goBind: '連携へ',
        service1: '初心者ガイド',
        service2: '副将紹介',
        service3: 'Lobi',
        service4: 'Discord',
        pushway: 'オススメ',
        allway: '攻略一覧',
    },
    pay: {
        payMethod: 'お支払い方法',
        creditCardDesc: 'クレジットカード',
        docomoMethod: 'd 払い(キャリア)',
        softBank: 'ソフトバ',
        cardNum: 'クレジットカード番号',
        endDate: '有効期限',
        cvc: 'セキュリティコード',
        payRule: '新規カードで支払い',
        methods1: 'お支払方法',
        adultConvent: '20歳未満の場合は購入ができません。同意のうえ、ご購入ください',
        auDesc: 'auかんたん決済',
        docomoDesc: 'd 払い(キャリア)',
        softbankDesc: 'ソフトバン',
        error1: '不明なエラーが発生しました。管理者にご連絡ください',
        paySuccess: 'チャージは完了です。ゲーム内で確認してください!',
        payClose1: 'このページは後',
        payClose2: '秒にオフします',
        payError: 'お支払いに失敗しました!',
        payCancel: 'お支払はキャンセルされました!',
        payBindInfo: 'まずログインしてからチャージしてください',
        sendReward: '購入',
        bindRecharge: 'お支払方法の追加',
        reward1: 'アカウント設定の完了をするにはお支払いオプションを追加してください',
        reward2: 'アカウントの設定します',
        support1: 'FAQ',
        support2: 'お問合せ',
        support3: 'この機能はまだ未開放です',
    },
    img: {
        login: 'ログイン',
        exChangeAcc: 'アカウント　切り替え',
        bindInfo: '連携について',
        submitPay: 'お支払い',
        resetPass: 'パスワード変更',
        saveBtn: '保存',
        confirmBtn: '確定',
        cancelBtn: 'キャンセル',
        bindEmail: '連携について',
        emailLogin: 'メールアドレスでログイン',
    },
    secondary: {
        maniInfo: 'ショートカットを追加'
    },
    logout: {
        outSuccess: 'ゲストアカウントを切り替えました',
        outFail: '操作に失敗しました、もう一度やり直してください',
    }
};

